import { render } from "./IconRoute.vue?vue&type=template&id=0e0b0f61"
import script from "./IconRoute.vue?vue&type=script&lang=js"
export * from "./IconRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__